<app-activity-card
  [headerTitle]="headerTitle"
  [expirationDate]="expirationDate"
  [picture]="picture"
  [businessId]="businessId"
  [couponStatus]="couponStatus"
  [usedDate]="usedDate"
  [note]="note"
  activityType="coupon"
  [id]="id"
  isCouponVip
>
  <div class="coupon-card-root">
    <div class="left-block">
      <div class="block">
        <span class="title">{{ 'reseller' | transloco }}</span>
        <span class="block-content">
          <p>
            {{ resellerName }}
          </p>
        </span>
      </div>
      <div class="block">
        <span class="title">{{ 'discount-code' | transloco }}</span>
        <span class="block-content">{{ codeVip }}</span>
      </div>
      <div class="block">
        <span class="title">{{ 'discount-value-vip' | transloco }}</span>
        <span class="block-content discount">{{ discount }}%</span>
      </div>
    </div>
    <div class="right-block">
      <div class="block">
        <span class="title">{{ 'ink-discount-models' | transloco }}</span>
        <span class="block-content">{{ uniqueModel | transloco }}</span>
      </div>
      <div class="block">
        <span class="title">{{ 'issued-date' | transloco }}</span>
        <span class="block-content">{{ startingDate }}</span>
      </div>
    </div>
  </div>
</app-activity-card>
